// ANCHOR React
import React, { useState } from 'react';

// ANCHOR Base
import {
  SharedProps, Tab, TabOverrides, Tabs, TabsOverrides,
} from 'baseui/tabs';

// ANCHOR Hooks
import { useConstantCallback } from '@lyon/utils/hooks/useConstantCallback';

// ANCHOR Styles
import { TAB, TABS } from './styles';

export interface ITab {
  key: string;
  title: string;
  isDisabled?: boolean;
  tabContent: React.ReactNode;
}

export interface ITabOverrides {
  tabs?: TabsOverrides<SharedProps>;
  tab?: TabOverrides<SharedProps>;
}

interface IProps {
  tabs: ITab[];
  overrides?: ITabOverrides;
}

export const ContentWideTabs = ({ tabs, overrides }: IProps) => {
  const [active, setActive] = useState(tabs[0].key);

  const handleChange = useConstantCallback(({ activeKey }) => {
    setActive(activeKey);
  });

  return (
    <Tabs
      onChange={handleChange}
      activeKey={active}
      overrides={overrides?.tabs ?? TABS}
      renderAll
    >
      {
        tabs.map((tab) => (
          <Tab
            key={tab.key}
            title={tab.title}
            disabled={tab.isDisabled}
            overrides={overrides?.tab ?? TAB}
          >
            {tab.tabContent}
          </Tab>
        ))
      }
    </Tabs>
  );
};
